import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=4370c5af&"
import script from "./NumberInfo.vue?vue&type=script&lang=js&"
export * from "./NumberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4370c5af')) {
      api.createRecord('4370c5af', component.options)
    } else {
      api.reload('4370c5af', component.options)
    }
    module.hot.accept("./NumberInfo.vue?vue&type=template&id=4370c5af&", function () {
      api.rerender('4370c5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NumberInfo/NumberInfo.vue"
export default component.exports